/*
 * @Author: Lemon C
 * @Date: 2024-04-19 12:22:25
 * @LastEditTime: 2024-05-17 17:17:21
 */
import { ElMessage } from 'element-plus'
let messageInstance = null
const resetMessage = (options) => {
    if (messageInstance) {
        messageInstance.close()
    }
    messageInstance = ElMessage(options)
}
['error', 'success', 'info', 'warning'].forEach(type => {
    resetMessage[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options
            }
        }
        options.type = type;
        options.offset = 100;
        options.duration = 5000;
        return resetMessage(options)
    }
})
export default resetMessage
